module.exports = __webpack_public_path__ + "img/faq.2cbcb8de.png";